import React from "react";
import { DURATION_COPY } from "./DurationPicker.copy";
import type { DurationPickerProps, DurationUnit } from "./DurationPicker.types";
import { DURATION_PRESETS, DURATION_UNITS, formatUntil } from "./durationPicker.helpers";
import { useDurationPickerInternalState } from "./useDurationPickerInternalState";
import { Dropdown } from "../Dropdown";
import { Amount, Row, Until, Wrap } from "./DurationPicker.styles";

/** Presets plus a custom amount and unit; gives an ISO expires_at, or null for never. */
export const DurationPicker: React.FC<DurationPickerProps> = ({ value, onChange, now, disabled = false, className }) => {
  const s = useDurationPickerInternalState({ value, onChange, now });
  return (
    <Wrap className={className}>
      <Row>
        <Dropdown<string>
          ariaLabel={DURATION_COPY.presetLabel}
          value={s.selected}
          disabled={disabled}
          onSelect={s.pickPreset}
          options={[
            ...DURATION_PRESETS.map((p) => ({ value: p.id, label: p.label })),
            { value: "custom", label: DURATION_COPY.custom },
          ]}
        />
      </Row>
      {s.selected === "custom" ? (
        <Row>
          <Amount
            type="number"
            min={1}
            aria-label={DURATION_COPY.amountLabel}
            value={s.amount}
            disabled={disabled}
            onChange={(e) => s.changeCustom(Number(e.target.value), s.unit)}
          />
          <Dropdown<DurationUnit>
            ariaLabel={DURATION_COPY.unitLabel}
            value={s.unit}
            disabled={disabled}
            onSelect={(u) => s.changeCustom(s.amount, u)}
            options={DURATION_UNITS.map((u) => ({ value: u, label: u }))}
          />
        </Row>
      ) : null}
      <Until>{value ? DURATION_COPY.until(formatUntil(value)) : DURATION_COPY.noExpiry}</Until>
    </Wrap>
  );
};

export default DurationPicker;
